/* ============================================================
   BLOG — filtri per categoria + ricerca live
   ============================================================ */

(function () {
  const root = document.querySelector('[data-blog-root]');
  if (!root) return;

  const articles = root.querySelectorAll('[data-article]');
  const catButtons = root.querySelectorAll('.blog-v1-cat');
  const searchInput = root.querySelector('[data-blog-search]');
  const searchClear = root.querySelector('[data-blog-search-clear]');
  const emptyState = root.querySelector('[data-blog-empty]');
  const resetButton = root.querySelector('[data-blog-reset]');
  const countEl = root.querySelector('[data-count]');
  const totalCount = articles.length;

  let activeCat = 'Tutti';
  let searchQuery = '';

  function applyFilters() {
    const q = searchQuery.trim().toLowerCase();
    let visibleCount = 0;

    articles.forEach((el) => {
      const tagsAttr = el.getAttribute('data-tags') || '';
      const tags = tagsAttr.split('|').map((t) => t.trim()).filter(Boolean);
      const haystack = (el.getAttribute('data-search') || '').toLowerCase();

      const catMatch = activeCat === 'Tutti' || tags.includes(activeCat);
      const searchMatch = !q || haystack.includes(q);

      const show = catMatch && searchMatch;
      el.style.display = show ? '' : 'none';
      if (show) visibleCount++;
    });

    if (emptyState) {
      emptyState.style.display = visibleCount === 0 ? '' : 'none';
    }
    if (countEl) {
      countEl.textContent = activeCat === 'Tutti' ? totalCount : visibleCount;
    }
  }

  catButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      catButtons.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      activeCat = btn.getAttribute('data-cat') || 'Tutti';
      applyFilters();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      searchQuery = e.target.value;
      if (searchClear) {
        searchClear.style.display = searchQuery ? '' : 'none';
      }
      applyFilters();
    });
  }

  if (searchClear) {
    searchClear.addEventListener('click', () => {
      searchInput.value = '';
      searchQuery = '';
      searchClear.style.display = 'none';
      applyFilters();
    });
  }

  if (resetButton) {
    resetButton.addEventListener('click', () => {
      catButtons.forEach((b) => b.classList.remove('is-active'));
      const allBtn = root.querySelector('[data-cat="Tutti"]');
      if (allBtn) allBtn.classList.add('is-active');
      activeCat = 'Tutti';
      searchQuery = '';
      if (searchInput) searchInput.value = '';
      if (searchClear) searchClear.style.display = 'none';
      applyFilters();
    });
  }
})();